"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieConsentClient = void 0;
const tslib_1 = require("tslib");
const utils_1 = require("../utils");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
class CookieConsentClient {
    constructor({ options: { domainKey, withGoogleConsent = false, scriptSource = constants_1.ONETRUST_SCRIPT_URL, }, }) {
        if (!domainKey) {
            throw new Error(constants_1.ERROR_MESSAGES.WRONG_DOMAIN_KEY);
        }
        this.config = { domainKey, withGoogleConsent, scriptSource };
    }
    init(onConsentGivenCallbacks = []) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!(0, utils_1.isBrowser)()) {
                throw new Error(constants_1.ERROR_MESSAGES.NOT_IN_BROWSER);
            }
            if ((0, utils_1.isOneTrustInitialised)()) {
                return;
            }
            if (this.config.withGoogleConsent) {
                (0, helpers_1.initializeGoogleConsent)();
            }
            (0, helpers_1.onConsentGiven)(onConsentGivenCallbacks);
            yield (0, helpers_1.loadOneTrustScript)(this.config.domainKey, this.config.scriptSource);
        });
    }
    /**
     * Displays cookie consent preference center (settings)
     */
    showSettings() {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.OneTrust) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
        }
    }
    /**
     * Retrieves domain information from OneTrust
     */
    getDomainData() {
        var _a;
        if ((_a = window === null || window === void 0 ? void 0 : window.OneTrust) === null || _a === void 0 ? void 0 : _a.GetDomainData) {
            return window.OneTrust.GetDomainData();
        }
    }
    /**
     * Checks if user has given consent based on cookie consent banner status
     */
    isConsentGiven() {
        return (0, utils_1.isCookieConsentGiven)();
    }
    /**
     * Retrieves active category IDs based on user's consent
     */
    getActiveCategoryIds() {
        return (0, utils_1.getActiveCategoryIds)();
    }
    /**
     * Checks if user has rejected all optional categories of cookie consent
     */
    hasUserRejectedAllCategories() {
        return (0, utils_1.hasUserRejectedAllCategories)();
    }
}
exports.CookieConsentClient = CookieConsentClient;
//# sourceMappingURL=CookieConsentClient.js.map